module.exports = __webpack_public_path__ + "static/media/nissan-light.186618d9.woff";